<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
      <el-form-item label="数据类型">
          <el-select v-model="queryForm.dayType" style="width: 175px" placeholder="请选择数据类型">
              <el-option
                  v-for="item in typeEnumList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
              </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="查询日期">
          <el-date-picker
              v-model="queryForm.dayDate"
              style="width: 175px"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择查询日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getReportDailyList">查询</el-button>
          <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addReportDaily"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editReportDaily(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteReportDaily(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportReportDailyList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshReportDailyList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="reportDailyList"
      row-key="id"
      height="100%"
      border
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="日期"
        width="200"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayValue"
        label="数值"
        width="200"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayType"
        label="类型"
        width="200"
      >
        <template slot-scope="scpe">
            {{ computeType(scpe.row.dayType) }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkReportDaily(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editReportDaily(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteReportDaily(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="reportDailyStates[reportDailyState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="reportDaily"
          ref="reportDailyForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="日期"
            prop="dayDate"
          >
            <el-input
              size="small"
              style="width: 175px"
              v-model="reportDaily.dayDate"
              :disabled="reportDailyState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="数值"
            prop="dayValue"
          >
            <el-input
              size="small"
              style="width: 175px"
              v-model="reportDaily.dayValue"
              :disabled="reportDailyState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="类型"
            prop="dayType"
          >
            <!-- <el-input
              size="small"
              v-model="reportDaily.dayType"
              :disabled="reportDailyState == 'check'"
            ></el-input> -->
            <el-select v-model="reportDaily.dayType" style="width: 175px" :disabled="reportDailyState == 'check'" placeholder="请选择数据类型">
              <el-option
                  v-for="item in typeEnumList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
              </el-option>
          </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="reportDailyState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetReportDailyList();
                    this.getReportDailyList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetReportDailyList();
                    this.getReportDailyList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     dayDate: '', //日期
                     dayValue: '', //数值
                     dayType: '', //类型
                },
                typeEnumList:[], //类型枚举
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                reportDailyState: 'add',
                reportDailyStates: {
                    add: '新建数据',
                    check: '查看数据',
                    edit: '修改数据'
                },

                multipleSelection: [],
                reportDailyList: [],
                reportDaily: {
                    dayDate: '', //日期
                    dayValue: '', //数值
                    dayType: '', //类型
                },
                btnLoading: false,

                rules: {
                    dayDate: [{ required: true, message: '日期不能为空', trigger: 'blur' }],
                    dayValue: [{ required: true, message: '数值不能为空', trigger: 'blur' }],
                    dayType: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getReportDailyList();
            this.getTypeEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetReportDailyList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.reportDailyList = [];
            },
            resetDialog() {
                this.reportDailyState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      dayDate: '', //日期
                      dayValue: '', //数值
                      dayType: '', //类型
                };
                this.getReportDailyList();
            },
            closeDialog() {
                this.reportDaily = {
                      dayDate: '', //日期
                      dayValue: '', //数值
                      dayType: '', //类型
                };
            },
            submitForm() {
                if (this.reportDailyState == 'add') {
                    this.$refs.reportDailyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/report/reportdaily/add`,{ ...this.reportDaily }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetReportDailyList();
                                    this.resetDialog();
                                    this.getReportDailyList();
                                }
                            });
                        }
                    });
                } else if (this.reportDailyState == 'edit') {
                    this.$refs.reportDailyForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/report/reportdaily/edit`,{ ...this.reportDaily }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetReportDailyList();
                                    this.resetDialog();
                                    this.getReportDailyList();
                                }
                            });
                        }
                    });
                }
            },
            addReportDaily() {
                this.showDialog = true;
                this.reportDailyState = 'add';
            },
            checkReportDaily(reportDailyId) {
                console.log(reportDailyId);
                this.currentReportDailyId = reportDailyId;

                this.getReportDailyById();
                this.showDialog = true;
                this.reportDailyState = 'check';
            },
            editReportDaily(reportDailyId) {
                console.log('reportDaily', reportDailyId);
                if (reportDailyId) {
                    this.currentReportDailyId = reportDailyId;
                    this.getReportDailyById();
                } else {
                    this.reportDaily = { ...this.reportDaily, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.reportDailyState = 'edit';
            },
            deleteReportDaily(reportDailyId) {
                let ids = '';
                if (reportDailyId) {
                    ids = reportDailyId;
                } else {
                    ids = this.multipleSelection.map((reportDaily) => reportDaily.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/report/reportdaily/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetReportDailyList();
                                this.getReportDailyList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshReportDailyList() {
                this.resetReportDailyList();
                this.getReportDailyList();
            },
            getReportDailyList(query = {}) {
                this.loading = true;
                get(`/report/reportdaily/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.reportDailyList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getReportDailyById() {
                get(`/report/reportdaily/get`,{ id: this.currentReportDailyId }).then((res) =>{
                    if(res.success){
                      this.reportDaily = { ...this.reportDaily, ...res.reportDaily };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportReportDailyList() {
                //this.btnLoading = true;
                exprotExcel(`/report/reportdaily/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/report/reportdaily/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/report/reportdaily/importData`,formData);
              this.refreshReportDailyList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getReportDailyList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getReportDailyList();
            },

            // 获取类型枚举
            getTypeEnum(){
                get('/mpp/utils/getEnum',{ enumType:'report_data_type' }).then((res)=>{
                    this.typeEnumList = res.enumList
                })
            },

            // 计算类型
            computeType(type){
                for (let i = 0; i < this.typeEnumList.length; i++) {
                    if(this.typeEnumList[i].key == type){
                        return this.typeEnumList[i].value
                    }
                }
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
